import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "@jem-open/jem-ui";

type DeleteDraftModalProps = {
  open: boolean;
  messageTitle: string;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteDraftModal: React.FC<DeleteDraftModalProps> = ({ open, messageTitle, isDeleting, onClose, onConfirm }) => (
  <Dialog open={open} onOpenChange={(o: boolean) => { if (!o && !isDeleting) onClose(); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Delete draft</DialogTitle>
        <DialogDescription>
          Are you sure you want to delete &ldquo;{messageTitle}&rdquo;? This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline" disabled={isDeleting}>Cancel</Button>
        </DialogClose>
        <Button
          className="bg-red-500 hover:bg-red-600"
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default DeleteDraftModal;
